/**
 * 输入框上面的模型信息展示
 */
import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import modelChoiceStore from '@/components/model-choice/store';
import { Divider } from 'antd';

const isBusiness = true;
const logo_bus = 'https://p1.ssl.qhimg.com/t110b9a9301febade753c8c1e58.png';
const logo_default = 'https://p1.ssl.qhimg.com/t110b9a9301febade753c8c1e58.png';
const icon_default = 'https://p1.ssl.qhimg.com/t110b9a93018295fdd8f951fb2c.png';
const InputHeader = observer(({ logo, showModel = true }) => {
  const { frontIds, list } = modelChoiceStore;
  const modelInfo = useMemo(() => {
    const frontId = frontIds[0];
    const item = list.find(item => item.id === frontId);
    return item;
  }, [list, frontIds]);
  return (
    <>
      <div className="w-full flex items-center justify-center mb-40px z-2 relative">
        <img className="h-50px" src={isBusiness ? logo_bus : logo_default} alt="" />
        <Divider
          className={['h-20px bg-[rgba(0,0,0,.2)]', isBusiness ? '!mx-20px' : '!mx-15px']}
          type="vertical"
        />
        {logo && <img className="w-112px h-48px" src={logo} alt="" />}
      </div>
      <div className=" w-full max-w-800px min-w-652px h-56px bg-[#F0F7FF] flex items-center z-2 relative rounded-t-12px p-12px">
        {showModel && (
          <img className="size-32px rounded-full mr-8px" src={modelInfo?.icon || icon_default} />
        )}
        {showModel && (
          <span className="text-14px font-medium text-[#252D4D] mr-8px">
            {modelInfo?.home_recommend || modelInfo?.title || ''}
          </span>
        )}
        {showModel && (
          <span className="text-12px flex-1 text-[rgba(37,45,77,0.45)] whitespace-nowrap overflow-hidden text-ellipsis">
            {modelInfo?.description || ''}
          </span>
        )}
      </div>
    </>
  );
});
export default InputHeader;
